
<template>
    <v-card>
        <v-card-text>
            <v-row class="pl-5">
                <v-col cols="12">
                    <v-data-table :headers="machinesHeaders" :items="machines">
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="secondary" icon>
                                <v-icon @click="openRenameDialog(item)">mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn color="primary" icon>
                                <v-icon @click="openConfigDialog(item)">mdi-cog-outline</v-icon>
                            </v-btn>
                            <v-btn color="error" icon>
                                <v-icon @click="deleteMachine(item)">mdi-delete-outline</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
                <v-col cols="12" class="pa-3 d-flex justify-end">
                    <v-btn color="primary" fab class="ml-3" @click="machineCreationDialog = true">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-dialog v-model="machineRenameDialog" scrollable persistent max-width="500px">
                <v-card>
                    <v-card-title class="headline">Renommer la machine</v-card-title>
                    <v-card-text>
                        <v-text-field label="Nom de la machine" v-model="machineRenameName"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="machineRenameDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="renameMachine">Renommer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="machineCreationDialog" scrollable persistent max-width="500px">
                <v-card>
                    <v-card-title class="headline">Ajouter une machine</v-card-title>
                    <v-card-text>
                        <v-text-field label="Nom de la machine" v-model="machineCreationName"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="machineCreationDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="createMachine">Ajouter</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <MachineConfig ref="machineConfigDialog"/>
        </v-card-text>
    </v-card>
</template>

<script>

import Swal from 'sweetalert2/dist/sweetalert2.js'

import Machine from '@/classes/Machine'

import MachineConfig from '@/components/assets/machines/MachineConfig'

export default {
    name: "MachineAssetsList",
    components: {
        MachineConfig
    },
    data() {
        return {
            unsub : [],
            machinesHeaders : [
                { text: 'Nom', value: 'name' },
                { text: '', value: 'actions', sortable: false, align: 'right' },
            ],
            machines : [],
            machineRenameDialog : false,
            machineRenameName : "",
            machineCreationDialog : false,
            machineCreationName : "",
        }
    },
    created() {
        this.unsub.push(Machine.listenAll((machines) => {
            this.machines = machines
            this.machines.sort((a, b) => (a.name > b.name) ? 1 : -1)
        }))
    },
    methods: {
        createMachine() {
            if(this.machineCreationName.trim() != ""){
                Machine.initializeOne(this.machineCreationName).then((machine) => {
                    machine.save()
                    this.machineCreationDialog = false;
                })
            }
        },
        openRenameDialog(machine) {
            this.machineRenameSelectedMachine = machine
            this.machineRenameName = machine.name
            this.machineRenameDialog = true
        },
        openConfigDialog(machine) {
            this.$refs.machineConfigDialog.openDialog(machine)
        },
        renameMachine() {
            this.machineRenameSelectedMachine.name = this.machineRenameName
            this.machineRenameSelectedMachine.save()
            this.machineRenameDialog = false
        },
        deleteMachine(machine){
            Swal.fire({
                title: 'Etes vous sûr ?',
                text: 'Voulez vous vraiment supprimer cette machine ?',
                icon: 'question',
                confirmButtonText: 'Confirmer',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    machine.delete()
                }
            })
        },
    },
    destroyed() {
        this.unsub.forEach((unsub) => {
            if(typeof unsub == "function"){
                unsub()
            }
        })
    },
}
</script>